import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AdminService } from '../../api';
import { LoginAlertService, Alert } from '../login-alert.service';

@Component({ templateUrl: 'login.component.html' })
export class AdminLoginComponent implements OnInit {
  loginForm: FormGroup;

  successMessage = null;
  errorMessage = null;
  isLoading = false;

  private formSubmitAttempt = false;

  constructor(
    private sessionService: AdminService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: LoginAlertService
  ) {
    this.loginForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.required],
    });
  }

  public ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      // Pre-populate the email field when it's provided as a route query param
      const email = params?.email;
      if (email) {
        this.loginForm.patchValue({ email });
      }
    });

    this.alertService.alert$.subscribe((alert: Alert) => {
      if (!alert) {
        this.errorMessage = null;
        this.successMessage = null;
        return;
      }

      switch (alert.type) {
        case 'success':
          this.successMessage = alert.message;
          break;
        case 'error':
          this.errorMessage = alert.message;
          break;
      }
    });
  }

  isInvalid(field: string): boolean {
    return !!(
      this.loginForm.get(field).invalid &&
      (this.loginForm.get(field).touched || this.formSubmitAttempt)
    );
  }

  onSubmit() {
    this.formSubmitAttempt = true;

    if (this.loginForm.invalid) {
      return;
    }

    const userData = this.loginForm.value;

    this.isLoading = true;

    this.sessionService.login(userData).subscribe(
      (data) => {
        this.router.navigateByUrl('/');
      },
      (data) => {
        this.formSubmitAttempt = false;
        this.isLoading = false;

        this.alertService.setAlert({
          type: 'error',
          message: data.error.message,
        });

        this.loginForm.controls.password.reset();
      }
    );
  }
}
